<div class="patient-info-window"
  [ngClass]="{
    minimized: patientInfoWindow.minimized,
    pinned: patientInfoWindow.pinned,
    'pinned-left': patientInfoWindow.pinSide === 'left',
    'pinned-right': patientInfoWindow.pinSide === 'right',
    'pinned-top': patientInfoWindow.pinSide === 'top',
    'pinned-bottom': patientInfoWindow.pinSide === 'bottom',
    dragging: patientInfoWindow.dragging,
    resizing: patientInfoWindow.resizing,
    'resize-shadow': patientInfoWindow.resizeHoverDir || patientInfoWindow.resizing
  }"
  [ngStyle]="getPatientInfoWindowStyle()"
  aria-label="patient info window">
  <div *ngFor="let handle of patientInfoResizeHandles"
    class="patient-info-resize-handle"
    [ngClass]="handle"
    (pointerenter)="onPatientInfoResizeHandleEnter(handle)"
    (pointerleave)="onPatientInfoResizeHandleLeave(handle)"
    (pointerdown)="onPatientInfoResizePointerDown($event, handle)">
  </div>

  <div class="patient-info-header"
    (pointerdown)="onPatientInfoHeaderPointerDown($event)"
    (dblclick)="togglePatientInfoMinimize($event)">
    <div class="patient-info-title">
      <span class="patient-info-minimized-label">
        <mat-icon *ngIf="patientInfoWindow.minimized && patientInfoWindow.pinned; else patientInfoMinimizedTextTpl">
          {{patientInfoPinnedMinimizedIcon}}
        </mat-icon>
        <ng-template #patientInfoMinimizedTextTpl>{{patientInfoMinimizedLabel}}</ng-template>
      </span>
      <strong class="patient-info-title-text" [title]="patientInfoWindowTitle">{{patientInfoWindowTitle}}</strong>
      <!-- <span class="patient-info-subtitle">病患資訊</span> -->
    </div>
    <div class="patient-info-actions">
      <button type="button"
        class="patient-info-action patient-info-pin-action"
        [class.active]="patientInfoWindow.pinned"
        [title]="getPatientInfoPinTitle()"
        [attr.aria-label]="getPatientInfoPinTitle()"
        (click)="togglePatientInfoPin($event)">
        <mat-icon
          [class.pinned]="patientInfoWindow.pinned"
          [class.unpinned]="!patientInfoWindow.pinned">push_pin</mat-icon>
      </button>
      <button type="button"
        class="patient-info-action"
        [title]="getPatientInfoMinimizeTitle()"
        [attr.aria-label]="getPatientInfoMinimizeTitle()"
        (click)="togglePatientInfoMinimize($event)">
        <mat-icon>{{patientInfoWindow.minimized ? 'open_in_full' : 'remove'}}</mat-icon>
      </button>
    </div>
  </div>

  <form class="patient-info-search" autocomplete="off" (submit)="onPatientInfoSearchSubmit($event)">
    <div class="patient-info-search-field">
      <input
        class="patient-info-search-input"
        type="text"
        name="patientInfoSearchKeyword"
        [ngModel]="patientInfoSearchKeyword"
        (ngModelChange)="onPatientInfoSearchKeywordChange($event)"
        placeholder="患者檢索"
        autocomplete="off"
        (focus)="onPatientInfoSearchInputFocus()"
        (blur)="onPatientInfoSearchInputBlur()"
        (keydown.enter)="onPatientInfoSearchSubmit($event)"
        [disabled]="patientInfoSearchLoading">
      <div
        *ngIf="patientInfoSearchSuggestionsVisible && patientInfoSearchSuggestions.length"
        class="patient-info-search-suggestions">
        <button
          *ngFor="let suggestion of patientInfoSearchSuggestions"
          type="button"
          class="patient-info-search-suggestion"
          (mousedown)="$event.preventDefault()"
          (click)="selectPatientInfoSearchSuggestion(suggestion)">
          {{suggestion}}
        </button>
      </div>
    </div>
    <button
      type="submit"
      class="patient-info-search-button"
      [disabled]="patientInfoSearchLoading || !patientInfoSearchKeyword.trim()"
      title="search patient">
      <mat-icon>{{patientInfoSearchLoading ? 'hourglass_empty' : 'search'}}</mat-icon>
    </button>
  </form>

  <details
    *ngIf="patientInfoSearchResultsKeyword"
    class="patient-info-search-group patient-info-search-results"
    [open]="!patientInfoSearchResultsCollapsed"
    (toggle)="onPatientInfoSearchResultsToggle($event)">
    <summary class="patient-info-search-group-summary patient-info-search-group-header">
      <span class="patient-info-search-summary-main">
        <span class="patient-info-toggle-icon" aria-hidden="true">
          <span class="patient-info-toggle-line patient-info-toggle-line-a"></span>
          <span class="patient-info-toggle-line patient-info-toggle-line-b"></span>
        </span>
        <span class="patient-info-search-keyword">{{patientInfoSearchResultsKeyword}}</span>
      </span>
      <span class="patient-info-search-count">{{patientInfoSearchResults.length || 0}} 筆</span>
    </summary>

    <div class="patient-info-search-group-body">
      <!-- <div *ngIf="!patientInfoSearchResults.length" class="patient-info-no-result">查無患者資料</div> -->
      <div *ngIf="patientInfoSearchError" class="patient-info-search-error">
        {{patientInfoSearchError}}
      </div>

      <button *ngFor="let patient of patientInfoSearchResults"
        type="button"
        class="patient-info-result-item"
        [class.selected]="isPatientInfoSelected(patient)"
        (click)="selectPatientInfoSearchResult(patient)">
        <span class="patient-info-result-name">{{getPatientInfoDisplayName(patient)}}</span>
        <span class="patient-info-result-meta">
          <span *ngIf="patient.PatientNo">{{patient.PatientNo}}</span>
          <span *ngIf="patient.Kcstmr">{{patient.Kcstmr}}</span>
          <span *ngIf="getPatientInfoBirthday(patient)">{{getPatientInfoBirthday(patient)}}</span>
          <span *ngIf="getPatientInfoPrimaryPhone(patient)">{{getPatientInfoPrimaryPhone(patient)}}</span>
        </span>
      </button>
    </div>
  </details>

  <div class="patient-info-body">
    <ng-container *ngIf="hasPatientInfoPanelContent; else patientInfoEmptyTpl">
      <section *ngIf="patientInfoSelectedPatient" class="patient-info-current">
        <div class="patient-info-current-header">
          <div class="patient-info-current-name">
            <span class="patient-info-current-name-text">{{getPatientInfoDisplayName(patientInfoSelectedPatient)}}</span>
            <mat-icon
              *ngIf="getPatientInfoSexIcon(patientInfoSelectedPatient)"
              class="patient-info-sex-icon"
              [ngClass]="getPatientInfoSexClass(patientInfoSelectedPatient)"
              [title]="getPatientInfoSexTitle(patientInfoSelectedPatient)"
              [attr.aria-label]="getPatientInfoSexTitle(patientInfoSelectedPatient)">
              {{getPatientInfoSexIcon(patientInfoSelectedPatient)}}
            </mat-icon>
            <span *ngIf="getPatientInfoAgeText(patientInfoSelectedPatient)" class="patient-info-current-age"
              [ngClass]="patientInfoCurrentAgeClass">
              {{getPatientInfoAgeText(patientInfoSelectedPatient)}}
            </span>
          </div>
          <button
            type="button"
            class="patient-info-current-edit patient-info-current-reserve"
            title="預約"
            aria-label="預約"
            (click)="onPatientInfoReserveClick($event)">
            <mat-icon>event</mat-icon>
          </button>
          <button
            *ngIf="enableEdit"
            type="button"
            class="patient-info-current-edit"
            title="修改基本資料"
            aria-label="修改基本資料"
            (click)="onPatientInfoEditClick($event)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <div class="patient-info-current-meta">
          <span *ngIf="getPatientInfoPrimaryNoLabel(patientInfoSelectedPatient)">{{getPatientInfoPrimaryNoLabel(patientInfoSelectedPatient)}}</span>
          <span *ngIf="getPatientInfoBirthday(patientInfoSelectedPatient)">生　日 {{getPatientInfoBirthday(patientInfoSelectedPatient)}}</span>
          <span *ngIf="getPatientInfoCId(patientInfoSelectedPatient)">身分證 {{getPatientInfoCId(patientInfoSelectedPatient)}}</span>
          <span *ngIf="getPatientInfoMobile(patientInfoSelectedPatient)">手　機 {{getPatientInfoMobile(patientInfoSelectedPatient)}}</span>
          <span *ngIf="getPatientInfoHomePhone(patientInfoSelectedPatient)">電　話 {{getPatientInfoHomePhone(patientInfoSelectedPatient)}}</span>
          <span
            *ngFor="let tag of patientInfoAlertTags"
            class="patient-info-alert-tag"
            [ngClass]="tag.cssClass"
            [matTooltip]="tag.tooltip"
            matTooltipPosition="above"
            [attr.aria-label]="tag.tooltip">
            {{tag.label}}
          </span>
        </div>

        <details
          *ngIf="patientInfoFamilyLoading || patientInfoFamilyMembers.length"
          class="patient-info-search-group patient-info-section-group patient-info-family"
          [open]="patientInfoSectionExpanded.family"
          (toggle)="onPatientInfoSectionToggle('family', $event)">
          <summary class="patient-info-search-group-summary patient-info-search-group-header">
            <span class="patient-info-search-summary-main">
              <span class="patient-info-toggle-icon" aria-hidden="true">
                <span class="patient-info-toggle-line patient-info-toggle-line-a"></span>
                <span class="patient-info-toggle-line patient-info-toggle-line-b"></span>
              </span>
              <span class="patient-info-search-keyword">家族成員</span>
            </span>
            <span class="patient-info-search-count">{{patientInfoFamilyLoading ? '讀取中' : (patientInfoFamilyMembers.length + ' 筆')}}</span>
          </summary>

          <div class="patient-info-search-group-body patient-info-section-body">
            <button *ngFor="let member of patientInfoFamilyMembers"
              type="button"
              class="patient-info-result-item patient-info-family-item"
              [class.selected]="isPatientInfoSelected(member)"
              (click)="selectPatientInfoFamilyMember(member)">
              <span class="patient-info-result-name">{{getPatientInfoDisplayName(member)}}</span>
              <span class="patient-info-result-meta">
                <span *ngIf="member.PatientNo">{{member.PatientNo}}</span>
                <span *ngIf="getPatientInfoBirthday(member)">{{getPatientInfoBirthday(member)}}</span>
                <span *ngIf="getPatientInfoPrimaryPhone(member)">{{getPatientInfoPrimaryPhone(member)}}</span>
              </span>
            </button>
          </div>
        </details>

        <div class="patient-info-register-info">
          <details
            *ngIf="patientInfoRegisterInfoLoading || patientInfoActiveTreatments.length"
            class="patient-info-search-group patient-info-section-group patient-info-subsection"
            [open]="patientInfoSectionExpanded.activeTreatments"
            (toggle)="onPatientInfoSectionToggle('activeTreatments', $event)">
            <summary class="patient-info-search-group-summary patient-info-search-group-header">
              <span class="patient-info-search-summary-main">
                <span class="patient-info-toggle-icon" aria-hidden="true">
                  <span class="patient-info-toggle-line patient-info-toggle-line-a"></span>
                  <span class="patient-info-toggle-line patient-info-toggle-line-b"></span>
                </span>
                <span class="patient-info-search-keyword">進行中療程</span>
              </span>
              <span class="patient-info-search-count">{{patientInfoRegisterInfoLoading ? '讀取中' : (patientInfoActiveTreatments.length + ' 筆')}}</span>
            </summary>
            <div class="patient-info-search-group-body patient-info-section-body">
            <div *ngFor="let item of patientInfoActiveTreatments" class="patient-info-mini-row patient-info-treatment-row">
              <div class="patient-info-mini-row-main">
                <span class="patient-info-mini-row-name">{{getPatientInfoTreatmentTypeName(item)}}</span>
                <span
                  *ngIf="getPatientInfoTreatmentStartDate(item)"
                  class="patient-info-mini-row-date">開始 {{getPatientInfoTreatmentStartDate(item)}}</span>
                <span class="patient-info-treatment-actions">
                  <!-- <button
                    type="button"
                    class="patient-info-action patient-info-treatment-action"
                    style="width: 42px;"
                    (click)="onPatientInfoFollowDentalTreatment(item, $event)">
                    跟療
                  </button> -->
                  <button
                    type="button"
                    class="patient-info-action patient-info-treatment-action danger"
                    style="width: 42px;"
                    (click)="onPatientInfoFinishDentalTreatment(item, $event)">
                    結束
                  </button>
                </span>
              </div>
              <div class="patient-info-mini-row-meta">
                <span *ngIf="getPatientInfoTreatmentCardNo(item)">卡序 {{getPatientInfoTreatmentCardNo(item)}}</span>
                <span *ngIf="getPatientInfoTreatmentCountText(item)">次數 {{getPatientInfoTreatmentCountText(item)}}</span>
                <span *ngIf="getPatientInfoTreatmentToothPos(item)">牙位 {{getPatientInfoTreatmentToothPos(item)}}</span>
                <span *ngIf="getPatientInfoTreatmentOrdersDisplay(item)">{{getPatientInfoTreatmentOrdersDisplay(item)}}</span>
              </div>
            </div>
            </div>
          </details>

          <details
            class="patient-info-search-group patient-info-section-group patient-info-subsection"
            [open]="patientInfoSectionExpanded.periodItems"
            (toggle)="onPatientInfoSectionToggle('periodItems', $event)">
            <summary class="patient-info-search-group-summary patient-info-search-group-header">
              <span class="patient-info-search-summary-main">
                <span class="patient-info-toggle-icon" aria-hidden="true">
                  <span class="patient-info-toggle-line patient-info-toggle-line-a"></span>
                  <span class="patient-info-toggle-line patient-info-toggle-line-b"></span>
                </span>
                <span class="patient-info-search-keyword">週期性項目</span>
              </span>
              <span class="patient-info-search-count">{{patientInfoRegisterInfoLoading ? '讀取中' : (patientInfoPeriodItems.length + ' 筆')}}</span>
            </summary>
            <div class="patient-info-search-group-body patient-info-section-body">
            <div *ngIf="!patientInfoRegisterInfoLoading && !patientInfoPeriodItems.length" class="patient-info-no-result">
              無可用資料
            </div>
            <div *ngFor="let item of patientInfoPeriodItems" class="patient-info-mini-row">
              <div class="patient-info-mini-row-main">
                <span class="patient-info-mini-row-name">{{item.PeriodItemName}}</span>
                <span class="patient-info-mini-row-actions">
                  <button
                    type="button"
                    class="patient-info-mini-icon-action patient-info-period-reserve-action"
                    title="預約"
                    aria-label="預約"
                    (click)="onPatientInfoReservePeriodItem(item, $event)">
                    <mat-icon>event</mat-icon>
                  </button>
                  <mat-icon
                    class="patient-info-mini-status"
                    [class.allow]="item.IsAllowExecute"
                    [class.deny]="!item.IsAllowExecute">
                    {{item.IsAllowExecute ? 'check_circle' : 'close'}}
                  </mat-icon>
                </span>
              </div>
              <div class="patient-info-mini-row-meta">
                <span *ngIf="item.PeriodMonths">週期 {{item.PeriodMonths}}</span>
                <span *ngIf="getPatientInfoPeriodDate(item.PreviousDate)">上次 {{getPatientInfoPeriodDate(item.PreviousDate)}}</span>
                <span *ngIf="getPatientInfoPeriodDate(item.ExecutableDate)">可執行 {{getPatientInfoPeriodDate(item.ExecutableDate)}}</span>
                <span *ngIf="getPatientInfoPeriodRxCodes(item)">{{getPatientInfoPeriodRxCodes(item)}}</span>
              </div>
            </div>
            </div>
          </details>

          <details
            *ngIf="patientInfoRegisterInfoLoading || patientInfoReserveRecords.length"
            class="patient-info-search-group patient-info-section-group patient-info-subsection patient-info-reserve-record-section"
            [open]="patientInfoSectionExpanded.reserveRecords"
            (toggle)="onPatientInfoSectionToggle('reserveRecords', $event)">
            <summary class="patient-info-search-group-summary patient-info-search-group-header">
              <span class="patient-info-search-summary-main">
                <span class="patient-info-toggle-icon" aria-hidden="true">
                  <span class="patient-info-toggle-line patient-info-toggle-line-a"></span>
                  <span class="patient-info-toggle-line patient-info-toggle-line-b"></span>
                </span>
                <span class="patient-info-search-keyword">預約紀錄</span>
              </span>
              <span class="patient-info-search-count">{{patientInfoRegisterInfoLoading ? '讀取中' : (patientInfoReserveRecords.length + ' 筆')}}</span>
            </summary>
            <div class="patient-info-search-group-body patient-info-section-body">
              <div *ngIf="!patientInfoRegisterInfoLoading && !patientInfoReserveRecords.length" class="patient-info-no-result">
                無可用資料
              </div>
              <button
                *ngFor="let item of patientInfoReserveRecords"
                type="button"
                class="patient-info-mini-row patient-info-mini-row-button patient-info-reserve-record-row"
                [class.expired]="isPatientInfoReserveRecordExpiredToday(item)"
                (click)="onPatientInfoReserveRecordClick(item, $event)">
                <div class="patient-info-mini-row-main">
                  <span class="patient-info-mini-row-name">{{getPatientInfoReserveRecordTitle(item)}}</span>
                  <span *ngIf="getPatientInfoReserveRecordDate(item)" class="patient-info-mini-row-date">{{getPatientInfoReserveRecordDate(item)}}</span>
                </div>
                <div class="patient-info-mini-row-meta">
                  <span *ngIf="getPatientInfoReserveRecordTimeRange(item)">{{getPatientInfoReserveRecordTimeRange(item)}}</span>
                  <span *ngIf="item.DoctorName">{{item.DoctorName}}</span>
                  <span *ngIf="getPatientInfoRoomName(item.RoomCode)">{{getPatientInfoRoomName(item.RoomCode)}}</span>
                  <span *ngIf="isPatientInfoReserveRecordExpiredToday(item)">今日已逾期</span>
                </div>
              </button>
            </div>
          </details>

          <details
            *ngIf="patientInfoRegisterInfoLoading || patientInfoClinicHistories.length"
            class="patient-info-search-group patient-info-section-group patient-info-subsection patient-info-history-section"
            [class.has-pager]="hasPatientInfoClinicHistoryPager"
            [open]="patientInfoSectionExpanded.clinicHistories"
            (toggle)="onPatientInfoSectionToggle('clinicHistories', $event)">
            <summary class="patient-info-search-group-summary patient-info-search-group-header">
              <span class="patient-info-search-summary-main">
                <span class="patient-info-toggle-icon" aria-hidden="true">
                  <span class="patient-info-toggle-line patient-info-toggle-line-a"></span>
                  <span class="patient-info-toggle-line patient-info-toggle-line-b"></span>
                </span>
                <span class="patient-info-search-keyword">近期病歷</span>
              </span>
              <span class="patient-info-search-count">{{patientInfoClinicHistories.length ? patientInfoClinicHistoryPageText : (patientInfoRegisterInfoLoading ? '讀取中' : '0 筆')}}</span>
            </summary>
            <div class="patient-info-search-group-body patient-info-section-body">
            <div *ngIf="!patientInfoRegisterInfoLoading && !patientInfoClinicHistories.length" class="patient-info-no-result">
              無可用資料
            </div>
            <button
              *ngFor="let item of patientInfoClinicHistoryPageItems"
              type="button"
              class="patient-info-mini-row patient-info-mini-row-button patient-info-history-row"
              [attr.data-hist-id]="getPatientInfoClinicHistoryHistId(item) || null"
              [attr.data-reg-id]="getPatientInfoClinicHistoryRegId(item) || null"
              [attr.data-hrx-id]="getPatientInfoClinicHistoryHRxId(item) || null"
              (click)="onPatientInfoClinicHistoryClick(item, $event)">
              <div class="patient-info-mini-row-main">
                <span class="patient-info-mini-row-name">{{item.RxCode || item.StdCode}}</span>
                <span *ngIf="getPatientInfoClinicHistoryDate(item)" class="patient-info-mini-row-date">{{getPatientInfoClinicHistoryDate(item)}}</span>
              </div>
              <div class="patient-info-mini-row-meta">
                <span *ngIf="item.ToothPos">牙位 {{item.ToothPos}}<span *ngIf="item.Way">({{item.Way}})</span></span>
                <span *ngIf="getPatientInfoClinicHistoryDxCodes(item)">診斷 {{getPatientInfoClinicHistoryDxCodes(item)}}</span>
              </div>
            </button>
            <div *ngIf="hasPatientInfoClinicHistoryPager" class="patient-info-pager">
              <button
                type="button"
                [disabled]="!canPagePatientInfoClinicHistory(-1)"
                title="上一頁"
                (click)="pagePatientInfoClinicHistory(-1)">
                <mat-icon>chevron_left</mat-icon>
              </button>
              <span>{{patientInfoClinicHistoryPageText}}</span>
              <button
                type="button"
                [disabled]="!canPagePatientInfoClinicHistory(1)"
                title="下一頁"
                (click)="pagePatientInfoClinicHistory(1)">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
            </div>
          </details>
        </div>
      </section>
    </ng-container>

    <ng-template #patientInfoEmptyTpl>
      <div class="patient-info-empty">
        請先選擇患者或進行檢索
      </div>
    </ng-template>
  </div>
</div>

<div
  class="patient-info-simple-hist-overlay"
  [class.is-visible]="patientInfoSimpleHist.visible"
  [class.is-masked]="patientInfoSimpleHist.maskVisible"
  [ngStyle]="getPatientInfoSimpleHistOverlayStyle()"
  (click)="closePatientInfoSimpleHist($event)">
  <section
    class="patient-info-simple-hist-dialog"
    [ngClass]="{
      'patient-info-simple-hist-dialog-pinned': patientInfoSimpleHist.pinned,
      'patient-info-simple-hist-dialog-dragging': patientInfoSimpleHist.dragging,
      'patient-info-simple-hist-dialog-resizing': patientInfoSimpleHist.resizing
    }"
    [ngStyle]="getPatientInfoSimpleHistDialogStyle()"
    [attr.data-reg-id]="getPatientInfoSimpleHistRegId() || null"
    [attr.data-hist-id]="getPatientInfoClinicHistoryHistId(patientInfoSimpleHist.source) || null"
    [attr.data-hrx-id]="getPatientInfoClinicHistoryHRxId(patientInfoSimpleHist.source) || null"
    (click)="$event.stopPropagation()">
    <div *ngFor="let handle of getPatientInfoSimpleHistResizeHandles()"
      class="patient-info-simple-hist-resize-handle"
      [ngClass]="handle"
      (pointerenter)="onPatientInfoSimpleHistResizeHandleEnter(handle)"
      (pointerleave)="onPatientInfoSimpleHistResizeHandleLeave(handle)"
      (pointerdown)="onPatientInfoSimpleHistResizePointerDown($event, handle)">
    </div>
    <header class="patient-info-simple-hist-header"
      (pointerdown)="onPatientInfoSimpleHistHeaderPointerDown($event)">
      <div>
        <span>{{getPatientInfoSimpleHistTitle()}} 病歷快覽</span>
      </div>
      <button
        type="button"
        class="patient-info-action patient-info-simple-hist-edit"
        title="編輯完整病歷"
        aria-label="編輯完整病歷"
        [disabled]="!getPatientInfoSimpleHistRegId()"
        (click)="openPatientInfoSimpleHistFullRecord($event)">
        <mat-icon>edit</mat-icon>
      </button>
      <button
        type="button"
        class="patient-info-action patient-info-pin-action patient-info-simple-hist-pin"
        [class.active]="patientInfoSimpleHist.pinned"
        [title]="getPatientInfoSimpleHistPinTitle()"
        [attr.aria-label]="getPatientInfoSimpleHistPinTitle()"
        (click)="togglePatientInfoSimpleHistPin($event)">
        <mat-icon [class.pinned]="patientInfoSimpleHist.pinned">push_pin</mat-icon>
      </button>
      <button type="button" class="patient-info-action" title="關閉" aria-label="關閉" (click)="closePatientInfoSimpleHist($event)">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="patient-info-simple-hist-body">
      <div *ngIf="patientInfoSimpleHist.loading" class="patient-info-simple-hist-message">
        載入病歷資料中...
      </div>
      <div *ngIf="!patientInfoSimpleHist.loading && patientInfoSimpleHist.error" class="patient-info-simple-hist-message error">
        {{patientInfoSimpleHist.error}}
      </div>

      <ng-container *ngIf="!patientInfoSimpleHist.loading && !patientInfoSimpleHist.error && patientInfoSimpleHist.data">
        <div
          class="patient-info-simple-hist-text-grid"
          [class.compact-note-cc]="!getPatientInfoSimpleHistRemark() && !getPatientInfoSimpleHistCc()">
          <section>
            <h4>特記</h4>
            <p>{{getPatientInfoSimpleHistRemark() || '無資料'}}</p>
          </section>
          <section>
            <h4>主訴</h4>
            <p>{{getPatientInfoSimpleHistCc() || '無資料'}}</p>
          </section>
          <section>
            <h4>理學/處置說明</h4>
            <p>{{getPatientInfoSimpleHistPe() || '無資料'}}</p>
          </section>
        </div>

        <section class="patient-info-simple-hist-table-section">
          <table>
            <thead>
              <tr>
                <th>診察費代碼</th>
                <th>名稱</th>
                <th>加成</th>
                <th>單價</th>
                <th>小計</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let order of getPatientInfoSimpleHistOrders('examFee')">
                <td>{{getPatientInfoSimpleHistOrderCode(order)}}</td>
                <td>{{getPatientInfoSimpleHistOrderName(order)}}</td>
                <td>{{order.Plus || ''}}</td>
                <td>{{order.Price || order.IPrice || ''}}</td>
                <td>{{order.Tot || ''}}</td>
              </tr>
              <tr *ngIf="!hasPatientInfoSimpleHistOrders('examFee')">
                <td colspan="5">無資料</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section class="patient-info-simple-hist-table-section patient-info-simple-hist-diag-section">
          <h4>診斷代碼</h4>
          <div class="patient-info-simple-hist-diag-list">
            <span *ngFor="let diag of getPatientInfoSimpleHistDiags()">
              {{getPatientInfoSimpleHistDiagLabel(diag)}}
            </span>
            <span class="patient-info-simple-hist-diag-empty" *ngIf="!getPatientInfoSimpleHistDiags().length">
              無資料
            </span>
          </div>
        </section>

        <section class="patient-info-simple-hist-table-section">
          <table>
            <thead>
              <tr>
                <th>處置代碼</th>
                <th>名稱</th>
                <th>牙位</th>
                <th>牙面</th>
                <th>PCS</th>
                <th>數量</th>
                <th>加成</th>
                <th>單價</th>
                <th>小計</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let order of getPatientInfoSimpleHistOrders('treatment')">
                <td>{{getPatientInfoSimpleHistOrderCode(order)}}</td>
                <td>{{getPatientInfoSimpleHistOrderName(order)}}</td>
                <td>{{order.ToothPos || ''}}</td>
                <td>{{order.ToothFace || ''}}</td>
                <td>{{order.PCS || ''}}</td>
                <td>{{getPatientInfoSimpleHistOrderQty(order)}}</td>
                <td>{{order.Plus || ''}}</td>
                <td>{{order.Price || order.IPrice || ''}}</td>
                <td>{{order.Tot || ''}}</td>
              </tr>
              <tr *ngIf="!hasPatientInfoSimpleHistOrders('treatment')">
                <td colspan="9">無資料</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section class="patient-info-simple-hist-table-section">
          <table>
            <thead>
              <tr>
                <th>處方代碼</th>
                <th>名稱</th>
                <th>次量</th>
                <th>頻率</th>
                <th>日</th>
                <th>總量</th>
                <th>途徑</th>
                <th>加成</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let order of getPatientInfoSimpleHistOrders('prescription')">
                <td>{{getPatientInfoSimpleHistOrderCode(order)}}</td>
                <td>{{getPatientInfoSimpleHistOrderName(order)}}</td>
                <td>{{order.Dose || ''}}</td>
                <td>{{order.Freq || ''}}</td>
                <td>{{order.Days || ''}}</td>
                <td>{{order.TotalDose || getPatientInfoSimpleHistOrderQty(order)}}</td>
                <td>{{order.Way || ''}}</td>
                <td>{{order.Plus || ''}}</td>
              </tr>
              <tr *ngIf="!hasPatientInfoSimpleHistOrders('prescription')">
                <td colspan="8">無資料</td>
              </tr>
            </tbody>
          </table>
        </section>
      </ng-container>
    </div>
  </section>
</div>

<ng-template #patientInfoDentalTreatmentEndTpl let-item>
  <div class="dental-picker-list patient-info-dental-picker-list">
    <details class="dental-picker-item" open>
      <summary class="dental-picker-summary">
        <div class="dental-picker-summary-main">
          <span class="dental-toggle-icon" aria-hidden="true">
            <span class="dental-toggle-line dental-toggle-line-a"></span>
            <span class="dental-toggle-line dental-toggle-line-b"></span>
          </span>
          <span class="dental-picker-date">{{getPatientInfoTreatmentStartDate(item)}}</span>
          <span>案類 {{getPatientInfoDentalTreatmentCaseType(item)}}</span>
          <span>牙位 {{getPatientInfoTreatmentToothPos(item) || '-'}}</span>
          <span>卡序 {{getPatientInfoTreatmentCardNo(item) || '-'}}</span>
          <span class="dental-picker-status" [class.ended]="isPatientInfoDentalTreatmentEnded(item)">
            {{getPatientInfoDentalTreatmentStatusText(item)}}
            <ng-container *ngIf="getPatientInfoDentalTreatmentDateEnd(item)">({{getPatientInfoDentalTreatmentDateEnd(item)}})</ng-container>
          </span>
          <span class="dental-picker-orders">{{getPatientInfoTreatmentOrdersDisplay(item)}}</span>
        </div>
      </summary>
      <table class="dental-picker-history">
        <thead>
          <tr>
            <th>看診日</th>
            <th>案類</th>
            <th>身分</th>
            <th>卡序</th>
            <th>牙位</th>
            <th>處置</th>
            <th>結束日</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let hist of getPatientInfoDentalTreatmentHistories(item)">
            <td>{{getPatientInfoDentalHistoryDate(hist)}}</td>
            <td>{{getPatientInfoDentalHistoryCaseType(hist)}}</td>
            <td>{{getPatientInfoDentalHistoryIdentity(hist)}}</td>
            <td>{{getPatientInfoDentalHistoryIsqnoDisplay(hist, item)}}</td>
            <td>{{getPatientInfoDentalHistoryToothPos(hist)}}</td>
            <td>{{getPatientInfoDentalHistoryOrders(hist)}}</td>
            <td>{{getPatientInfoDentalHistoryDateEnd(hist)}}</td>
          </tr>
        </tbody>
      </table>
    </details>
  </div>
</ng-template>
